<div class="title">{{ notification.title }}</div>
<div class="content">
  <div class="subject">{{ notification.subject }}</div>
  <ng-content select="[notification-actions]"></ng-content>
</div>
@if (notification.createdAt) {
  <div class="created-at">{{ notification.createdAt | momentFromNow: true }}</div>
}
<ng-content select="[notification-top-action]"></ng-content>
